import { getLocale } from '@/utils/locale';

/** @desc 替换Url locale 参数 */
export function replaceUrl(url, type) {
  // type: locale
  let str = ''
  if (type === 'locale') {
    let locale = getLocale()
    str = url.replace('${locale}', locale)
  }
  return str
}